export const EXTERNAL_LINKS = {
    APPLE_DEVELOPER_ENROLL: 'https://developer.apple.com/programs/enroll/',
    APPLE_DEVELOPER_HELP: 'https://digital-awesome-docs.notion.site/what-you-need-before-starting-with-digital-awesome',
    APPLE_DEVELOPER_ACCOUNT: 'https://developer.apple.com/account',
    APP_STORE_LISTING_GUIDE: 'https://digital-awesome-docs.notion.site/App-Store-Listing-Info-384fb6ff4b1c81388360e45175081d4d',
    GOOGLE_PLAY_CONSOLE_SIGNUP: 'https://play.google.com/console/signup',
    GOOGLE_PLAY_CONSOLE: 'https://play.google.com/console',
    GOOGLE_PLAY_DEVELOPER_GUIDE: 'https://digital-awesome-docs.notion.site/Setting-Up-Your-Google-Play-Account-30efb6ff4b1c8078a1ade508baef3fc2',
    GOOGLE_PLAY_VERIFICATION_GUIDE: 'https://digital-awesome-docs.notion.site/Verifying-Your-Google-Play-Account-383fb6ff4b1c8197a7e6cf0e5b2aa858',
    FIREBASE_CONSOLE: 'https://console.firebase.google.com/',
    FIREBASE_DOCS: 'https://digital-awesome-docs.notion.site/Setting-up-your-Firebase-Account-with-Digital-Awesome-707fb6ff4b1c8209b90d81e1c6e1d72b',
    // Step 1 of design review. If blanked, the step still renders but without a
    // play affordance.
    DESIGN_REVIEW_WALKTHROUGH: 'https://www.loom.com/share/81ec87c968f54252863603d325923463',
    HELP_DOCS: 'https://www.notion.so/digital-awesome-docs/Digital-Awesome-Common-Questions-Support-Doc-2f9fb6ff4b1c801abc24ec9790c5bb45',
} as const;
